import { render, staticRenderFns } from "./EnrollClientFileTask.vue?vue&type=template&id=f47102d8&"
import script from "./EnrollClientFileTask.vue?vue&type=script&lang=ts&"
export * from "./EnrollClientFileTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports